import { Box, Typography, useTheme } from "@mui/material";
import TrendsChart from "../../../components/charts/TrendsChart";

export default function DashboardLineBarChart({ label, data }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const rows = data?.rows || [];
  const bar = data?.bar || {};
  const line = data?.line || {};
  const chartMinWidth = Math.max(500, rows.length * 50);

  return (
    <Box
      sx={{
        backgroundColor: isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.02)",
        border: `1px solid ${isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)"}`,
        borderRadius: 1,
        p: { xs: 1.5, sm: 2.5 },
        boxShadow: isDark
          ? "0 2px 8px rgba(0,0,0,0.3)"
          : "0 2px 8px rgba(0,0,0,0.1)",
        height: "100%"
      }}
    >
      {label?.length > 0 && (
        <Typography
          variant="h6"
          sx={{ mb: 2, color: theme.palette.text.secondary, textAlign: "center" }}
        >
          {label}
        </Typography>
      )}

      {rows.length > 0 && (
        <Box sx={{ overflowX: "auto", overflowY: "hidden" }}>
          <Box sx={{ minWidth: chartMinWidth }}>
            <TrendsChart
              data={rows}
              barDataKey="bar"
              lineDataKey="line"
              barLabel={bar.label || "Value"}
              lineLabel={line.label || "Value"}
              barColor={bar.color || "#a855f7"}
              lineColor={line.color || "#22d3ee"}
              barAxisLabel={bar.axisLabel || bar.label || ""}
              lineAxisLabel={line.axisLabel || line.label || ""}
              lineValueSuffix={line.valueSuffix ?? "%"}
              height={320}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}
